import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonRouterOutlet } from '@ionic/angular/standalone';

@Component({
  selector: 'app-trips',
  templateUrl: './trips.page.html',
  styleUrls: ['./trips.page.scss'],
  standalone: true,
  imports: [RouterModule, IonRouterOutlet, CommonModule]
})
export class TripsPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
